import React from 'react';

// wordpress components
import { useState } from '@wordpress/element';
import {
	__experimentalInputControl as InputControl,
	Button,
	Flex,
	FlexBlock,
} from '@wordpress/components';

// local components
import StepTitle from './elements/StepTitle';

const CouponForm = (props) => {
	const [couponCode, setCouponCode] = useState('');
	const handleSubmit = async (event) => {
		// Block native form submission.
		event.preventDefault();

		// check if coupon code is empty
		// console.log('couponCode is:', couponCode);
		if (couponCode.length === 0) {
			props.notify({
				content: 'Coupon code cannot be empty.',
				status: 'error',
			});
			return;
		}

		// call external function
		props.setCoupon(couponCode);
	};

	return (
		<Flex className="step-holder">
			<StepTitle>Coupon Code</StepTitle>

			<br />
			<br />
			<br />

			{/* Coupon Code input */}
			<Flex className="section-title">Coupon</Flex>
			<InputControl
				className="card-holder-name"
				value={couponCode}
				onChange={(nextVal) => setCouponCode(nextVal)}
			/>

			<FlexBlock />

			{/* Submit button */}
			<Flex className="step-footer">
				<div>
					Safely encrypted and stored by our partner{' '}
					<a
						href="https://stripe.com/"
						target="_blank"
						rel="noreferrer"
					>
						Stripe
					</a>
				</div>

				<FlexBlock />

				<Button isPrimary onClick={(event) => handleSubmit(event)}>
					Apply Code
				</Button>
			</Flex>
		</Flex>
	);
};

export default CouponForm;
